import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import { emiratesId_Request } from "../../../../store/actions";
import { IKIOSKModel, IKioskMessage, IkioskMenuIds } from "../../../../models/kioskModel";
import emiratescard from '../../../../images/emirates-card.gif';
import { Ilanguages } from "../../../../models/utilitiesModel";
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";
let subscribe;

const EmiratesIdVerification: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("translations");
  const language: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG) ;
  const menutype: string = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.selectedPage || IkioskMenuIds.LOGINPAGE);
  const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
  useEffect(() => {
    if (menutype === IkioskMenuIds.INSERTEMIRATESID) {
      subscribe = setTimeout(() => {
        dispatch(emiratesId_Request());
      }, 5200);
    }
    return () => {
      clearTimeout(subscribe);
    }
  }, [dispatch,menutype]);
  return (
    <div className="kiosk-content h-100">
      <div className="content-sec w70 h-100 d-flex flex-column align-items-center justify-content-center text-center verfcontent">
        <img src={emiratescard} width="350" alt="" />
        <div style={{ marginLeft: "50px" }}>
          <h1 style={{ marginBottom: "20px" }}>{(getLabelConfigMsg(kioskConfigMsgs, language, "emiratesID") || t('kiosktranslation.emiratesID' + language))}</h1>
        </div>
      </div>
    </div>
  )
}
export default React.memo(EmiratesIdVerification);